// extracted by mini-css-extract-plugin
export default {"layout":"BonusMultiviewBonusDetailsPopup__layout--2b1","loader":"BonusMultiviewBonusDetailsPopup__loader--1tk"};